export default __webpack_public_path__ + "static/media/10.f224e44b.png";